"use client";

import classNames from "classnames";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { getEvents, imageUrlFor } from "../sanity/client";
import { ScribbleEvent } from "../sanity/sanity.types";
import styles from "./events.module.css";

export default function Events() {
  const { data: events = [] } = useSWR<ScribbleEvent[]>("events", getEvents);

  return (
    <>
      <h1 className="font-bold text-3xl mb-4">Upcoming Events</h1>

      <p>
        If you&apos;d be interested in booking your event at Scribble, check out
        our <Link to="/venue">venue page</Link> for more information and links
        to inquiry forms.
      </p>

      <p>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://mailchi.mp/953294f8f76e/scribble-email-list"
        >
          Sign up for our newsletter
        </a>{" "}
        to keep up with upcoming events!
      </p>

      <p>
        Many of our shows are livestreamed{" "}
        <a href="https://www.twitch.tv/scribblecommunity/videos">here</a> for
        those who are not able to attend.
      </p>

      <div className={classNames("flexGridThirds", styles.eventsGrid)}>
        {events.map((item) => {
          if (
            item.date &&
            new Date(item.date).getTime() >
              new Date().getTime() - 1000 * 60 * 60 * 6
          ) {
            return (
              <div
                className={classNames("col", styles.event)}
                key={item.slug + Math.random().toString()}
              >
                <p>
                  {new Date(item.date).toLocaleDateString("en-us", {
                    weekday: "long",
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    timeZone: "America/Los_Angeles",
                  })}
                </p>
                <Link to={"/event/" + item?.slug?.current}>
                  <div className={styles.thumb}>
                    <div className={styles.title}>
                      <h3 className="font-bold mb-4 text-lg">{item.title}</h3>
                    </div>
                    {item.image && (
                      <img
                        alt=""
                        loading="lazy"
                        src={imageUrlFor(item.image.asset?._ref ?? "")
                          .width(800)
                          .url()}
                      />
                    )}
                  </div>
                </Link>
              </div>
            );
          }
          return null;
        })}
      </div>

      <hr />

      <h1 className="font-bold text-3xl mb-4">Past Events</h1>

      <div
        className={classNames(
          "flexGridThirds",
          styles.eventsGrid,
          styles.pastEvents,
        )}
      >
        {events.reverse().map((item) => {
          if (
            item.date &&
            new Date(item.date).getTime() <
              new Date().getTime() - 1000 * 60 * 60 * 6
          ) {
            return (
              <div
                className={classNames("col", styles.event)}
                key={item.slug + Math.random().toString()}
              >
                <p>
                  {new Date(item.date).toLocaleDateString("en-us", {
                    weekday: "long",
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    timeZone: "America/Los_Angeles",
                  })}
                </p>
                <Link to={"/event/" + item?.slug?.current}>
                  <div className={styles.thumb}>
                    <div className={styles.title}>
                      <h3 className="font-bold mb-4 text-lg">{item.title}</h3>
                    </div>
                    {item.image && (
                      <img
                        alt=""
                        loading="lazy"
                        src={imageUrlFor(item.image.asset?._ref ?? "")
                          .width(800)
                          .url()}
                      />
                    )}
                  </div>
                </Link>
              </div>
            );
          }
          return null;
        })}
      </div>
    </>
  );
}
